/**
 * The account step a sign-in's session will be asked for, known from its own token before the
 * API is asked (uji A30, B20, C27). Every role requires the second step (2026-10-02), so the
 * enrolment refused every aal1 session with a 403 (`perlu_verifikasi_dua_langkah`, or
 * `harus_ganti_sandi` first): expected, but logged by the browser at every sign-in, where it
 * could hide a real failure. The sign-in now opens the step's screen itself and enrols once the
 * steps are done; the API keeps the rule (shared `periksaLangkah`) and still refuses.
 *
 * Read without verification, as a prediction only: a token whose claims cannot be read, a
 * session that passes, or a step that could differ by role or by a factor not known, gives
 * null, and the enrolment is asked as before. The one thing the refused enrolment also told is
 * an account SATU switched off or removed (the gate reads the account before the step): it is
 * now told by the enrolment after the step, with the same wipe.
 */
import { type KodeLangkah, langkahSesiTanpaPeran, sesiTautanEmail } from '@satu/shared'
import { isiToken } from '../sync/tokenPengguna'

/** The `amr` entries the token names (method only), skipping any it cannot read. */
function metode(amr: unknown): { method: string }[] {
  if (!Array.isArray(amr)) return []
  return amr.flatMap((a: unknown) =>
    typeof a === 'object' && a !== null && typeof (a as { method?: unknown }).method === 'string'
      ? [{ method: (a as { method: string }).method }]
      : [],
  )
}

/**
 * The step the API would ask of this token at the enrolment whatever the role, or null.
 * `adaFaktor`: whether the account has a verified factor, as GoTrue's sign-in answered (null:
 * not known, e.g. a token read back after a step).
 */
export function langkahDariToken(token: string, adaFaktor: boolean | null): KodeLangkah | null {
  const isi = isiToken(token)
  if (isi === null) return null
  const aal = isi.aal === 'aal1' || isi.aal === 'aal2' ? isi.aal : undefined
  const meta = isi.app_metadata
  const harusGantiSandi =
    typeof meta === 'object' &&
    meta !== null &&
    (meta as { harus_ganti_sandi?: unknown }).harus_ganti_sandi === true
  return langkahSesiTanpaPeran({
    aal,
    adaFaktor,
    harusGantiSandi,
    sesiTautan: sesiTautanEmail(metode(isi.amr)),
  })
}
